var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgABank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.25,
    fill: "#00D352"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0406 7.42228L11.7262 5.11182H9.08156L10.9079 7.42228H13.0406ZM16.3891 8.56228H14.0712V9.22505C13.3462 8.75289 12.4956 8.46443 11.5863 8.46443C8.93248 8.46443 6.78125 10.5977 6.78125 13.2275C6.78125 15.8583 8.93202 17.9915 11.5859 17.9915C12.496 17.9915 13.3462 17.703 14.0712 17.23V17.8937H16.3891V8.56228ZM11.5863 15.7743C10.1671 15.7743 9.0174 14.6343 9.0174 13.228C9.0174 11.8217 10.1671 10.6821 11.5863 10.6821C13.0051 10.6821 14.1534 11.8217 14.1534 13.228C14.1534 14.6343 13.0042 15.7743 11.5863 15.7743Z",
    fill: "#090A0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgABank);
export default __webpack_public_path__ + "static/media/a_bank.b50414dd444e6a34642c57cc30165754.svg";
export { ForwardRef as ReactComponent };